/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flash-messages-for[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]{font-size:28px;right:-27px;top:-12px}.flash-messages-for[_ngcontent-%COMP%]   .close[_ngcontent-%COMP%]:hover{outline:0}\n/*# sourceMappingURL=flash-messages-for.component.css.map*/"];
export { styles as styles };
